// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-wrapper{width:3rem}.bw-wrapper.bw-absolute{left:50%;position:absolute;top:50%;transform:translate(-50%, -50%)}.bw-loader{animation:bw-loading-spinner 1.5s infinite ease-in-out;animation-delay:-0.16s;animation-fill-mode:both;border-radius:50%;color:#0c0243;font-size:.5em;height:1em;margin:0 auto;position:relative;text-indent:-9999em;transform:scale(0.9) translateZ(0) translateY(-1em);width:1em}.bw-loader:before,.bw-loader:after{animation:bw-loading-spinner 1.5s infinite ease-in-out;animation-fill-mode:both;border-radius:50%;content:\"\";height:1em;position:absolute;top:0;width:1em}.bw-loader:before{animation-delay:-0.32s;left:-1.5em}.bw-loader:after{left:1.5em}.bw-loader.bw-center{margin:0 auto}.bw-loader.bw-greyTheme{color:#676767}@keyframes bw-loading-spinner{0%,80%,100%{box-shadow:0 1em 0 -0.5em}40%{box-shadow:0 1em 0 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "bw-wrapper",
	"absolute": "bw-absolute",
	"loader": "bw-loader",
	"loading-spinner": "bw-loading-spinner",
	"center": "bw-center",
	"greyTheme": "bw-greyTheme"
};
module.exports = ___CSS_LOADER_EXPORT___;
